import { creditCardMask } from '~/utils/masks';

import { ClientField } from './ClientPanels';
import { formatMoney } from './format';

export interface LimitCard {
  limiteCreditoUtilizado?: number;
  limiteEmprestimoUtilizado?: number;
  limiteExtraUtilizado?: number;
  limiteTotalUtilizado?: number;
  numeroCartao?: string;
  status?: string;
}

export interface LimitFallback {
  nome?: string;
  numeroCartao?: string;
  statusCartao?: string;
  limiteCreditoUtilizado?: number;
  limiteEmprestimoUtilizado?: number;
  limiteExtraUtilizado?: number;
  limiteTotal?: number;
  limiteTotalUtilizado?: number;
}

export const buildClientFields = (
  name: string | undefined,
  card: LimitCard | undefined,
  fallback?: LimitFallback,
): ClientField[] => {
  const cardNumber = card?.numeroCartao || fallback?.numeroCartao;

  return [
    { label: 'Nome', value: name || fallback?.nome || '-' },
    {
      label: 'Cartão',
      value: cardNumber ? creditCardMask(cardNumber).masked : '-',
    },
    {
      label: 'Status do cartão',
      value: card?.status || fallback?.statusCartao || '-',
    },
    {
      label: 'Limite total utilizado',
      value: formatMoney(
        card?.limiteTotalUtilizado ?? fallback?.limiteTotalUtilizado,
      ),
    },
    {
      label: 'Limite de compras',
      value: formatMoney(
        card?.limiteCreditoUtilizado ?? fallback?.limiteCreditoUtilizado,
      ),
    },
    {
      label: 'Limite de empréstimo',
      value: formatMoney(
        card?.limiteEmprestimoUtilizado ?? fallback?.limiteEmprestimoUtilizado,
      ),
    },
    {
      label: 'Limite extra 12x',
      value: formatMoney(
        card?.limiteExtraUtilizado ?? fallback?.limiteExtraUtilizado,
      ),
    },
    {
      label: 'Limite total',
      value: formatMoney(
        card?.limiteTotalUtilizado ??
          fallback?.limiteTotal ??
          fallback?.limiteTotalUtilizado,
      ),
    },
  ];
};

export const summarizeInvoices = (
  currentInvoice?: number,
  totalTransactions?: number,
): {
  currentInvoice?: number;
  futureInvoices?: number;
  debtTotal?: number;
} => {
  const futureInvoices =
    totalTransactions != null && currentInvoice != null
      ? Number((totalTransactions - currentInvoice).toFixed(2))
      : undefined;
  const debtTotal =
    currentInvoice != null && futureInvoices != null
      ? Number((currentInvoice + futureInvoices).toFixed(2))
      : undefined;

  return { currentInvoice, futureInvoices, debtTotal };
};
